import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IconDropdown } from '@app/shared/models/icon-dropdown';

@Component({
  selector: 'app-icon-dropdown',
  templateUrl: './icon-dropdown.component.html',
  styleUrls: ['./icon-dropdown.component.scss'],
})
export class IconDropdownComponent {
  @Input() title: string = '';
  @Input() value: string = '';
  @Input() options: IconDropdown[] = [];
  @Input() selected: IconDropdown = {} as IconDropdown;
  @Output() ngModelChange: EventEmitter<IconDropdown> = new EventEmitter<IconDropdown>(undefined);

  public selectedChange(selected: IconDropdown): void {
    this.ngModelChange.emit(selected);
  }
}
